export const debug = {
  information: 'Debug információ',
  parameters: 'Paraméterek',
  errorCode: 'Hibakód',
  details: 'Részletek',
  noDetails: 'Nincs részlet',
  error: 'Hiba',
  showInfo: 'Debug információk mutatása',
  hideInfo: 'Debug információk elrejtése'
}
